import React, { useState } from "react"
import PropTypes from "prop-types"
import { Ribbon } from "./styles"

const EnvironmentRibbon = ({ environment }) => {
  const [visible, setVisible] = useState(true)
  const handleClick = (event) => {
    event.preventDefault()
    setVisible(false)
  }

  if (!visible) return null
  return <Ribbon data-ribbon={environment} onClick={handleClick}></Ribbon>
}

EnvironmentRibbon.propTypes = {
  environment: PropTypes.string.isRequired
}

EnvironmentRibbon.defaultProps = {
  environment: ""
}

export default EnvironmentRibbon
